import { AxiosResponse } from 'axios';
import KrpTechopsAdminResource from '@/api/resource/KrpTechopsAdminResource';

export default class IsFederalHolidayResource extends KrpTechopsAdminResource {
  public async getIsFederalHoliday(dateString: string): Promise<any> {
    const url: string = `/api/rcx/config/is-federal-holiday/${dateString}`;

    const response: AxiosResponse = await this.apiClient.get(url);

    return response.data.data;
  }
}
